<template>
    <div>
        <h5>{{group_name }}</h5>
        <el-container>
            <el-aside width="180px">
                <SubMenu activeIndex="3" />
            </el-aside>
            <el-main>
                <AddMany :group_id="group_id" from="yunduixiang" />
            </el-main>
        </el-container>
    </div>
</template>
<script>
import axios from 'axios';
import { Button } from 'iview'
import config from '../config.js';
import SubMenu from './SubMenu.vue';
import AddMany from './cell/AddMany.vue'
export default {
    components: {
        SubMenu,
        Button,
        AddMany
    },
    data() {
        return {
            group_name: '',
            group_id: '',
            
        }
    },
    created() {
        this.group_id = this.$route.params.group_id
       
        this.getGroup()
    },
    methods: {
        getGroup() {
            let url = config.base_url + '/yun_table/yun_duixiang_groups/' + this.group_id
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                let res = response.data
                this.group_id = res.group_id
                this.group_name = res.group_name
            })
        },
        
    }
}
</script>
<style>
/*.download a{
    color: #fff;
}*/

</style>